<template>
    <div class="full-height color-txt">
        <s-form class="row">
            <div class="col-12 fl-x fl-j-sb">
                <h3 class="text-primary fs-lg-4 font-poppins-semibold">Reports</h3>
                <btn class="px-4 mt-2 ml-1" style="cursor: pointer" @click="BackToHome">Back</btn>
            </div>
            <div class="col-lg-4 mt-lg-5">
                <validated-select class="c-input-select input-border-primary" label="Embryo Transfer Reports" placeholder="Choose Report"
                                  v-model="reportType"
                                  :options="reportOptions"></validated-select>
            </div>
        </s-form>
        <div class="row">
            <div class="col-12" v-if="reportType==='Embryo Transfer'">
                <embryo-transfer/>
            </div>

        </div>
    </div>

</template>

<script>

import EmbryoTransfer from './reportComponents/EmbryoTransfer';

export default {
    name: 'ETReportHome',
    components: {
        EmbryoTransfer
    },
    data () {
        return {
            reportType: '',
            reportOptions: [
                { value: 'Embryo Transfer', label: 'Embryo Transfer' }
            ]
        };
    },
    methods: {
        BackToHome () {
            this.$router.push({ path: '/reports/' });
        }
    }
};
</script>

<style scoped>
</style>
